<template>
  <div class="department">
    <DpplTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ atsDepartmentName }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ atsDepartmentName }}
        </p>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  atsDepartmentName: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.department {
  max-width: 100%;
  overflow: hidden;

  :deep(p) {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    font-size: 13px;
    line-height: normal;
    color: @text-light;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
